<template>
  <div>
    <h1>Trwa logowanie, proszę czekać <br />(Login in progress, please wait)</h1>

    <div style="display: none" id="hiddenIframeBox"></div>

    <form id="pkp-intercity-form" action="https://bilet.intercity.pl/logowanie.jsp" method="post" ref="pkpIntercityForm">
      <input type="hidden" name="actlogin" value="Zaloguj+si%EA" />
      <input type="hidden" name="password" :value="password" />
      <input type="hidden" name="login" :value="login" />
      <input type="hidden" name="ref" value="30" />
    </form>
  </div>
</template>

<script>
export default {
  name: "TravelServicePKPIntercityView",
  data: () => ({
    login: null,
    password: null
  }),
  methods: {
    downloadAuth() {
      this.axios.get("travel-service/get-pkp-intercity").then(resp => {
        this.login = resp.data.login;
        this.password = resp.data.password;
        this.loginPkpIntercity();
      });
    },
    loginPkpIntercity() {
      const context = this;
      let iframeClearSession = document.createElement("iframe");
      iframeClearSession.onload = function() {
        let iframeNewSession = document.createElement("iframe");
        iframeNewSession.onload = function() {
          context.$refs.pkpIntercityForm.submit();
          //send post and redirect
        };
        iframeNewSession.src = "https://bilet.intercity.pl/lista_biletow.jsp";
        document.getElementById("hiddenIframeBox").appendChild(iframeNewSession);
      };
      iframeClearSession.src = "https://bilet.intercity.pl/wyloguj.jsp";
      document.getElementById("hiddenIframeBox").appendChild(iframeClearSession);
      // setTimeout(function() {
      //   let iframeNewSession = document.createElement("iframe");
      //   iframeNewSession.onload = function() {
      //     context.$refs.pkpIntercityForm.element.submit();
      //     //send post and redirect
      //   };
      //   iframeNewSession.src = "https://bilet.intercity.pl/lista_biletow.jsp";
      //   document.getElementById("hiddenIframeBox").appendChild(iframeNewSession);
      // }, 3000);
      //
      // setTimeout(function() {
      //     context.$refs.pkpIntercityForm.element.submit();
      // }, 6000);
    }
  },
  created() {
    this.downloadAuth();
  }
};
</script>

<style scoped></style>
